// extracted by mini-css-extract-plugin
module.exports = {"title":"animalDetails_title__1Oehj"};